var g = Object.defineProperty;
var w = (l, e, t) => e in l ? g(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t;
var i = (l, e, t) => w(l, typeof e != "symbol" ? e + "" : e, t);
import { flip as y, shift as b, offset as O, arrow as v, size as U, autoPlacement as I, hide as H, inline as T, computePosition as D } from "../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs";
import { isTextSelection as E, posToDOMRect as M } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { Plugin as C, PluginKey as z, NodeSelection as R } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { CellSelection as P } from "../../node_modules/prosemirror-tables/dist/index.mjs";
function V(l, e) {
  const t = Math.min(l.top, e.top), s = Math.max(l.bottom, e.bottom), n = Math.min(l.left, e.left), a = Math.max(l.right, e.right) - n, d = s - t, o = n, r = t;
  return new DOMRect(o, r, a, d);
}
class x {
  constructor({
    editor: e,
    element: t,
    view: s,
    updateDelay: n = 250,
    resizeDelay: h = 60,
    shouldShow: a,
    appendTo: d,
    getReferencedVirtualElement: o,
    options: r
  }) {
    i(this, "editor");
    i(this, "element");
    i(this, "view");
    i(this, "preventHide", !1);
    i(this, "updateDelay");
    i(this, "resizeDelay");
    i(this, "appendTo");
    i(this, "getReferencedVirtualElement");
    i(this, "updateDebounceTimer");
    i(this, "resizeDebounceTimer");
    i(this, "isVisible", !1);
    i(this, "scrollTarget", window);
    i(this, "floatingUIOptions", {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    });
    i(this, "shouldShow", ({
      view: e,
      state: t,
      from: s,
      to: n
    }) => {
      const { doc: h, selection: a } = t, { empty: d } = a, o = !h.textBetween(s, n).length && E(t.selection), r = this.element.contains(document.activeElement);
      return !(!(e.hasFocus() || r) || d || o || !this.editor.isEditable);
    });
    i(this, "mousedownHandler", () => {
      this.preventHide = !0;
    });
    /**
     * Handles clicks outside the editor and bubble menu.
     * When clicking outside both, hide the menu.
     */
    i(this, "documentMousedownHandler", (e) => {
      const t = e.target;
      this.element.contains(t) || this.view.dom.contains(t) || this.hide();
    });
    i(this, "dragstartHandler", () => {
      this.hide();
    });
    /**
     * Handles the window resize event to update the position of the bubble menu.
     * It uses a debounce mechanism to prevent excessive updates.
     * The delay is defined by the `resizeDelay` property.
     */
    i(this, "resizeHandler", () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    });
    i(this, "focusHandler", () => {
      setTimeout(() => this.update(this.editor.view));
    });
    i(this, "blurHandler", ({ event: e }) => {
      var t;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      e != null && e.relatedTarget && ((t = this.element.parentNode) != null && t.contains(e.relatedTarget)) || (e == null ? void 0 : e.relatedTarget) !== this.editor.view.dom && this.hide();
    });
    i(this, "handleDebouncedUpdate", (e, t) => {
      const s = !(t != null && t.selection.eq(e.state.selection)), n = !(t != null && t.doc.eq(e.state.doc));
      !s && !n || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(e, s, n, t);
      }, this.updateDelay));
    });
    i(this, "updateHandler", (e, t, s, n) => {
      const { composing: h } = e;
      if (h || !t && !s)
        return;
      if (!this.getShouldShow(n)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    });
    i(this, "transactionHandler", ({ transaction: e }) => {
      e.getMeta("bubbleMenu") === "updatePosition" && this.updatePosition();
    });
    this.editor = e, this.element = t, this.view = s, this.updateDelay = n, this.resizeDelay = h, this.appendTo = d, this.scrollTarget = (r == null ? void 0 : r.scrollTarget) ?? window, this.getReferencedVirtualElement = o, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...r
    }, this.element.tabIndex = 0, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), document.addEventListener("mousedown", this.documentMousedownHandler), this.update(s, s.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const e = [];
    return this.floatingUIOptions.flip && e.push(
      y(
        typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0
      )
    ), this.floatingUIOptions.shift && e.push(
      b(
        typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0
      )
    ), this.floatingUIOptions.offset && e.push(
      O(
        typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0
      )
    ), this.floatingUIOptions.arrow && e.push(v(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && e.push(
      U(
        typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0
      )
    ), this.floatingUIOptions.autoPlacement && e.push(
      I(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && e.push(
      H(
        typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0
      )
    ), this.floatingUIOptions.inline && e.push(
      T(
        typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0
      )
    ), e;
  }
  get virtualElement() {
    var h, a, d;
    const { selection: e } = this.editor.state, t = (h = this.getReferencedVirtualElement) == null ? void 0 : h.call(this);
    if (t)
      return t;
    if (!((d = (a = this.view) == null ? void 0 : a.dom) != null && d.parentNode))
      return;
    const s = M(this.view, e.from, e.to);
    let n = {
      getBoundingClientRect: () => s,
      getClientRects: () => [s]
    };
    if (e instanceof R) {
      let o = this.view.nodeDOM(e.from);
      const r = o.dataset.nodeViewWrapper ? o : o.querySelector("[data-node-view-wrapper]");
      r && (o = r), o && (n = {
        getBoundingClientRect: () => o.getBoundingClientRect(),
        getClientRects: () => [o.getBoundingClientRect()]
      });
    }
    if (e instanceof P) {
      const { $anchorCell: o, $headCell: r } = e, f = o ? o.pos : r.pos, m = r ? r.pos : o.pos, c = this.view.nodeDOM(f), u = this.view.nodeDOM(m);
      if (!c || !u)
        return;
      const p = c === u ? c.getBoundingClientRect() : V(
        c.getBoundingClientRect(),
        u.getBoundingClientRect()
      );
      n = {
        getBoundingClientRect: () => p,
        getClientRects: () => [p]
      };
    }
    return n;
  }
  updatePosition() {
    const e = this.virtualElement;
    e && D(e, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: t, y: s, strategy: n }) => {
      this.element.style.width = "max-content", this.element.style.position = n, this.element.style.left = `${t}px`, this.element.style.top = `${s}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(e, t) {
    const { state: s } = e, n = s.selection.from !== s.selection.to;
    if (this.updateDelay > 0 && n) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const h = !(t != null && t.selection.eq(e.state.selection)), a = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, h, a, t);
  }
  getShouldShow(e) {
    var o;
    const { state: t } = this.view, { selection: s } = t, { ranges: n } = s, h = Math.min(...n.map((r) => r.$from.pos)), a = Math.max(...n.map((r) => r.$to.pos));
    return ((o = this.shouldShow) == null ? void 0 : o.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: t,
      oldState: e,
      from: h,
      to: a
    })) || !1;
  }
  show() {
    var t;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1", (t = (typeof this.appendTo == "function" ? this.appendTo() : this.appendTo) ?? this.view.dom.parentElement) == null || t.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), document.removeEventListener("mousedown", this.documentMousedownHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}
const F = (l) => new C({
  key: typeof l.pluginKey == "string" ? new z(l.pluginKey) : l.pluginKey,
  view: (e) => new x({ view: e, ...l })
});
export {
  F as BubbleMenuPlugin,
  x as BubbleMenuView
};
